
import { mapGetters } from 'vuex'
import { Currency } from '~/plugins/Currency'

export default {
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      getUserIP: 'user/getUserIP',
    }),
  },
  methods: {
    Currency(p) {
      return Currency(p, this.getUserIP.currency)
    },
  },
}
